import React, { Suspense, lazy } from 'react';
import { useLocation } from 'react-router-dom';
import Header from "../../components/Header/index";
import { Spinner } from "react-bootstrap";
import Fallback from "../../components/Fallback/index";

// Layout component that maintains only the header
const MainLayout = ({ children, brokerData, loading, error, brokerUrl }) => {
    if (loading) {
        return <div className="loading-container"><Spinner /></div>;
    }
    
    if (error) {
        return <div className="error-container">Error loading broker data: {error}</div>;
    }
    
    if (!brokerData) {
        return <div className="no-data-container">No broker data available</div>;
    }
    
    return (
        <>
            <Header brokerData={brokerData} fetchpriority="high" brokerUrl={brokerUrl} />
            <main className="main-content">
                {children}
            </main>
        </>
    );
};

export default MainLayout;